import React, { useState } from "react";
import { Form, Input, Button, Card, message, Row, Col } from "antd";
import { AuthContextValue, useAuth } from "../providers/AuthProvider";
import axiosBaseURL from "../api";

const CreditScoringPage: React.FC = () => {
  const { user } = useAuth() as AuthContextValue; // useAuth hook returns user context
  const [loading, setLoading] = useState(false);
  const [creditScore, setCreditScore] = useState<number | null>(null);
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    setLoading(true);
    setCreditScore(null);
    try {
      const response = await axiosBaseURL.post(
        "/credit-scoring",
        {
          APIrequest_data: {
            source_bank: values.source_bank,
            customerId: values.customerId,
            loan_type: values.loan_type,
            loan_subtype: values.loan_subtype,
          },
        },
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );
      setCreditScore(
        response.data.e2c8c1c3_3c3e_3e35_8a8a_c3c3c3c3c3c3_agri_tech_crop
          ?.model_output?.credit_score || null
      );
      message.success("Credit Score generated successfully!");
      form.resetFields();
    } catch (error) {
      message.error("Failed to generate credit score. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        className="flex flex-col bg-white p-4"
        onFinish={onFinish}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Source Bank"
              name="source_bank"
              rules={[{ required: true, message: "Please enter source bank" }]}
            >
              <Input
                placeholder="Enter Source Bank"
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item
              label="Customer ID"
              name="customerId"
              rules={[{ required: true, message: "Please enter customer ID" }]}
            >
              <Input
                placeholder="Enter Customer ID"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Loan Type"
              name="loan_type"
              rules={[{ required: true, message: "Please enter loan type" }]}
            >
              <Input placeholder="Enter Loan Type" style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label="Loan Subtype"
              name="loan_subtype"
              rules={[{ required: true, message: "Please enter loan subtype" }]}
            >
              <Input
                placeholder="Enter Loan Subtype"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Generate Credit Score
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {/* Conditionally render Card after form submission */}
      {creditScore !== null && (
        <Card
          key="creditScoreCard"
          //type="inner"
          style={{ marginTop: "20px" }}
        >
          <p>
            <strong>Credit Score:</strong> {creditScore}
          </p>
        </Card>
      )}
    </>
  );
};

export default CreditScoringPage;
